import myTraderaItemActions from '../state/actions/my-tradera-items';

export const types = {
    LINK: 'LINK',
    EXTERNAL_LINK: 'EXTERNAL_LINK',
    DISPATCH: 'DISPATCH'
};

const getId = (item) => item.key;
const getIds = (item) => [item.itemId];

const fixItemUrlIfNeeded = (item = {}) => {
    // Fix this at backend?
    return item.itemUrl && item.itemUrl[0] !== '/'
        ? `/${item.itemUrl}`
        : item.itemUrl;
};

// isPrimaryAction = will be primary action unless one before has not already been set as primary action
// Hence, the order of the actions matter.
const commonActions = (item) => {
    const actions = {
        itemsFromSeller: () => ({
            id: getId(item),
            type: types.LINK,
            label: 'Säljarens annonser',
            getTranslatedLabel: (t) =>
                t('myt_itemCard_actions_itemsFromSeller'),
            url: `/profile/items/${item.seller.id}/${item.seller.cleanedAlias}`,
            gaLabel: 'SellerOtherItems',
            isVisible: () => !item.haveMultipleRows,
            isPrimaryAction: () => true
        })
    };
    return actions;
};

export const activeBuyerActions = (item, listViewType, memberId) => {
    const common = commonActions(item);
    const actions = [
        () => {
            const isLeading =
                item.bidInformation &&
                item.bidInformation.leadingBidder &&
                item.bidInformation.leadingBidder.id === memberId;
            const fixedItemUrl = fixItemUrlIfNeeded(item);
            return {
                id: getId(item),
                type: types.LINK,
                label: isLeading ? 'Öka maxbud' : 'Lägg bud',
                getTranslatedLabel: (t) =>
                    isLeading
                        ? t('myt_itemCard_actions_raiseMaxBid')
                        : t('myt_itemCard_actions_placeBid'),
                url: fixedItemUrl,
                gaLabel: isLeading ? 'RaiseMaxBid' : 'PlaceBid',
                buttonTheme: 'success',
                isVisible: () => true,
                isPrimaryAction: () => true
            };
        },
        common.itemsFromSeller,
        () => ({
            id: getId(item),
            type: types.DISPATCH,
            label: 'Dölj',
            getTranslatedLabel: (t) => t('myt_itemCard_actions_hide'),
            dispatch: (dispatch) => {
                dispatch(
                    myTraderaItemActions.buyerActiveItemsHideItems(
                        getIds(item),
                        listViewType
                    )
                );
            },
            gaLabel: 'HideBuyerActiveItem',
            isVisible: () =>
                (item.caller.leadingBidRemoved ||
                    (item.bidInformation.leadingBidder &&
                        item.bidInformation.leadingBidder.id !== memberId)) &&
                item.caller.hidden === false,
            isPrimaryAction: () => true
        }),
        () => ({
            id: getId(item),
            type: types.DISPATCH,
            label: 'Visa',
            getTranslatedLabel: (t) => t('myt_itemCard_actions_show'),
            dispatch: (dispatch) => {
                dispatch(
                    myTraderaItemActions.buyerActiveItemsShowItems(
                        getIds(item),
                        listViewType
                    )
                );
            },
            gaLabel: 'ShowBuyerActiveItem',
            isVisible: () => item.caller.hidden === true, // User should always be able to Show a hidden item, no matter if leading or not
            isPrimaryAction: () => true
        })
    ];
    return actions;
};

export const lostActions = (item, listViewType) => {
    const common = commonActions(item);
    const actions = [
        common.itemsFromSeller,
        () => ({
            id: getId(item),
            type: types.DISPATCH,
            label: 'Dölj',
            getTranslatedLabel: (t) => t('myt_itemCard_actions_hide'),
            dispatch: (dispatch) => {
                dispatch(
                    myTraderaItemActions.buyerActiveItemsHideItems(
                        getIds(item),
                        listViewType
                    )
                );
            },
            gaLabel: 'HideBuyerLostItem',
            isVisible: () => true,
            isPrimaryAction: () => true
        })
    ];
    return actions;
};
